import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { expertDomains } from "@/mocks/expertsData";

export default function ExpertsDomains() {
  return (
    <section id="domains" className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Expert Domains
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-tie-text-primary leading-tight">
                30+ Specializations. One Platform.
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                From lean manufacturing to digital transformation, every domain is covered by vetted practitioners with proven factory-floor experience.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {expertDomains.map((domain, index) => (
              <ScrollReveal key={domain.name} delay={index * 80}>
                <div className="group h-full p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-3 md:mb-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal flex items-center justify-center shrink-0">
                      <i className={`${domain.icon} text-white text-base`} />
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-tie-text-primary">
                      {domain.name}
                    </h3>
                  </div>
                  <p className="text-sm text-tie-text-secondary leading-relaxed mb-4">
                    {domain.description}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-tie-text-muted">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-user-line" />
                      {domain.experts} experts
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-folder-chart-line" />
                      {domain.projects} projects
                    </span>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}